module.exports = __webpack_public_path__ + "img/icon_box_yellow.4d01fd01.png";